import {CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { HomeComponent } from './home.component';
type PathMatch = "full" | "prefix" | undefined;
export const routes = [
  { path: '', component: HomeComponent, pathMatch: 'full' as PathMatch  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule,
  ],
  declarations: [
    HomeComponent,
  ]
})
export class HomeModule { }
